import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../tailwind/modal";
import ModalHeader from "../tailwind/modal-header";
import ModalBody from "../tailwind/modal-body";
import ModalFooter from "../tailwind/modal-footer";
import ModalDialog from "../tailwind/modal-dialog";

export interface ModalSidebarProps {
  children: ReactNode;
  show: boolean;
  onHide?: () => void;
}
function ModalSidebar({ children, show, onHide }: ModalSidebarProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="d-lg-block">{children}</div>
      <Modal show={show} className="rtl">
        <ModalDialog
          ClassName="brc-dark-l4 border-y-0 border-l-0 pr-lg-3"
          scrollable={true}
        >
          <ModalHeader
          // className="modal-header d-lg-none"
          >
            {/* .hide header in lg+ view */}
            <h5 className="modal-title text-primary-d1">
              {t("Filter.Results")}
            </h5>
            <button type="button" className="close" onClick={onHide}>
              <span aria-hidden>×</span>
            </button>
          </ModalHeader>
          <ModalBody className="pt-lg-1 px-1 ace-scrollbar">
            {children}
          </ModalBody>
          <ModalFooter>
            <div className="text-center">
              <button className="btn btn-info text-600 text-sm px-425 radius-2px mr-1  d-lg-inline-block">
                {t("Apply")}
              </button>
              <a
                href="#search-filters"
                data-toggle="modal"
                className="btn btn-info text-600 text-sm px-425 radius-2px mr-1 d-lg-none"
              >
                {t("Apply")}
              </a>
              <button className="btn btn-light-secondary btn-bgc-white text-600 text-sm px-3 radius-1px">
                {t("Reset")}
              </button>
            </div>
          </ModalFooter>
        </ModalDialog>
      </Modal>
    </>
  );
}
export default ModalSidebar;
